module.exports = __webpack_public_path__ + "media/images/dmc/city-kyoto-78c8ca3fc3bdf30b8b22ad37d26c779b.jpg";